document.addEventListener("DOMContentLoaded", function () {
  // No visibility toggling is needed anymore.
  // Labels like '2-Pack', '3-Pack', etc. are visible.

  // If you still want to do anything when a variant changes here's a hook for that:
  document.querySelectorAll('variant-selects').forEach(variantSelect => {
    variantSelect.addEventListener('change', () => {
      const selectedVariant = variantSelect.querySelector('input[type="radio"]:checked, select');
      console.log('Variant changed:', selectedVariant?.value || 'N/A');
      // You could trigger anything here if needed (analytics, custom logic, etc.)
    });
  });
});
